import { render, staticRenderFns } from "./PowerWriterContent.vue?vue&type=template&id=46abc396&scoped=true"
import script from "./PowerWriterContent.vue?vue&type=script&lang=js"
export * from "./PowerWriterContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46abc396",
  null
  
)

export default component.exports